export default __webpack_public_path__ + "static/redwood-2-ab534861e1adbaf92f64f74211dd3c5d.jpg";